/**
 * Created by Real0 on 2017/4/26.
 */
// ('transCode=fundpositionslist&pageno='+pageno+'&pagesz='+pagesz+'&playFlg=0',0);

$(function () {
    if (isRealName()) {
        var cardLen = loadValue('cardLen', false);
        if (!isNull(cardLen) && Number(cardLen) > 0) {
            getSalePosition();
        } else {
            $('#unbindCard').removeClass('none');
        }
    } else {
        $('#unbindCard').removeClass('none');
    }
});


function getPosition() {
    toApi('fundpositionslist.tml?playFlg=0', function (data) {

        if (data.funds.length === 0) {
            $('#unbindCard').removeClass('none');
            // setUnBindCardInfo('暂无持仓数据', '', 'wallet/recharge.html');
            return;
        }

        $('#haveCard').removeClass('none');
        var list1 = [];
        var list2 = [];

        data.funds.forEach(function (e) {
            e.assertMarketValue = toThousands(e.assertMarketValue);
            e.availableShare = toThousands(e.availableShare);
            var rateAndColor = numberFormatter(e.totlam, 2);
            e.totlam = rateAndColor.value;
            e.totlamcolor = rateAndColor.color;
            var rateAndColor2 = numberFormatter(e.yestodayPro, 2);
            e.yestodayPro = rateAndColor2.value;
            e.yestodayProColor = rateAndColor2.color;
            e.isShowFundExit = e.isSpecialOutFund == '1' && e.state == e.specialFundState;

            //组合没有持有份额，可用份额
            if (e.isPortfolioAsset === '1') {
                e.total_share = '-';
                e.availableShare = '-';
            }
            if (e.fundSubType === '1') {
                var temp = numberFormatter(e.totalIncomeYield, 2);
                e.totalIncomeYield = temp.value + '%';
                e.totalIncomeYieldColor = temp.color;
                e.openDate = '暂无';
                if (!isNull(e.openDateStart) && !isNull(e.openDateEnd)) {
                    e.openDate = Number(e.openDateStart.substring(4, 6)) + '月' + Number(e.openDateStart.substring(6, 8)) + '日' + '~' + Number(e.openDateEnd.substring(4, 6)) + '月' + Number(e.openDateEnd.substring(6, 8)) + '日';
                }
                list1.push(e);
            } else {
                list2.push(e);
            }
        });

        if (list1.length > 0) {
            $('#specialProductTitle').removeClass('none');
            $('#specialProductTable').removeClass('none');
            var htmlList = template('specialProduct', {
                "list": list1
            });
            $('#specialProductList').html(htmlList);
        }

        if (list2.length > 0) {
            $('#fundProductTitle').removeClass('none');
            $('#fundProductTable').removeClass('none');
            var htmlList = template('product', {
                "list": list2
            });
            $('#fundProduct').html(htmlList);
        }
    }, 'redemptionList', '');
}

function gotoNextPage(pageId, fundCode, shareType, fundType, isPortfolioAsset, fundSubType, productCode) {
    //货币加
    if (fundSubType == '3') {
        combinedTip('本产品需通过A加钱包APP进行查看');
        return;
    }

    if (productCode == "目标盈" || productCode == "止盈" || productCode == "智能定投") {
        combinedTip('本产品需通过A加钱包APP进行查看');
        return;
    }

    if (isPortfolioAsset == '1') {
        alertIknowMsg('组合持仓暂时无法查看详情');
        return;
    } else {
        window.location.href = window.phURL + pageId + '?fundCode=' + fundCode + '&shareType=' + shareType + '&fundType=' + fundType;
    }
}

function goDetail(pageId, fundCode, fundType, isPortfolioAsset, fundSubType, productCode) {
    //货币加
    if (fundSubType == '3') {
        combinedTip('本产品需通过A加钱包APP进行查看');
        return;
    } else if (productCode == "目标盈" || productCode == "止盈" || productCode == "智能定投") {
        combinedTip('本产品需通过A加钱包APP进行查看');
    } else if (isPortfolioAsset == '1') {
        //组合详情
        alertIknowMsg('组合持仓暂时无法查看详情');
        return;
    } else {
        window.location.href = window.phURL + pageId + '?fundCode=' + fundCode + '&fundType=' + fundType;
    }
}


// 新代码

function getSalePosition() {
    var params = {
        agencyNo: 'APLUS',
        channelCode: ''
    };
    toApi_toAcCg('S15Q427', params, function (res) {
        if (res.fundList.length === 0 && res.spFundList.length === 0) {
            $('#unbindCard').removeClass('none');
            // setUnBindCardInfo('暂无持仓数据', '', 'wallet/recharge.html');
            return;
        }

        $('#haveCard').removeClass('none');
        // 基金
        var fundList = [];
        res.fundList.forEach(function (item) {
            if (item.detailList && item.detailList.length > 0) {
                item.detailList.forEach(function (detail) {
                    if (detail.mainFlag == '1' && Number(detail.availableAmount) > 0) {
                        fundList.push(detail)
                    } else if (detail.mainFlag == '0') {
                        fundList.push(detail)
                    }
                })
            } else {
                fundList.push(item);
            }
        })
        fundList.forEach(function (fund) {
            fund.formatAvailableAmount = toThousands(fund.availableAmount);
            fund.formatAvailableShare = toThousands(fund.availableShare);
            fund.formatTotalShare = toThousands(fund.totalShare)
            fund.isPortfolioAsset = '0';

            var dayIncome;
            if (fund.dayIncomeMap && Object.keys(fund.dayIncomeMap).length > 0) {
                dayIncome = fund.dayIncomeMap[fund.profitCalculateDate] || 0.00;
            }
            fund.formatDayProfitAmount = numberFormatter(dayIncome).value;
            fund.formatDayProfitAmountColor = numberFormatter(dayIncome).color;
            var income = fund.fundType == '04' ? fund.profitAmountTotal : fund.holdProfitAmount;
            fund.formatIncome = numberFormatter(income).value;
            fund.formatIncomeColor = numberFormatter(income).color;
            fund.profitDateText = new Date().toLocaleDateString().replace('/', '').replace('/', '') === fund.profitCalculateDate ? '今日' : '昨日';

            fund.productName = fund.productName ? fund.productName : fund.fundName;
            if (fund.portfolioType && fund.portfolioType == "TP") {
                fund.productCode = "目标盈";
            } else if (fund.portfolioType && fund.portfolioType == "TY") {
                fund.productCode = "止盈";
            }else if (fund.portfolioType && fund.portfolioType == "IP") {
                fund.productCode = "智能定投";
            } else {
                fund.productCode = fund.productCode ? fund.productCode : fund.fundCode;
            }
        })
        console.log(fundList);
        if (fundList.length > 0) {
            $('#fundProductTitle').removeClass('none');
            $('#fundProductTable').removeClass('none');
            var htmlList = template('product', {
                "list": fundList
            });
            $('#fundProduct').html(htmlList);
        }

        // 专户资产
        var spFundList = res.spFundList;
        spFundList.forEach(function (sp) {
            sp.formatAvailableAmount = toThousands(sp.availableAmount);
            var daySPIncome;
            if (sp.dayIncomeMap && Object.keys(sp.dayIncomeMap).length > 0) {
                daySPIncome = sp.dayIncomeMap[sp.profitCalculateDate] || 0.00;
            }
            sp.formatDayProfitAmount = numberFormatter(daySPIncome).value;
            sp.formatDayProfitAmountColor = numberFormatter(daySPIncome).color;
            sp.formatProfitAmountTotal = numberFormatter(sp.holdProfitAmount).value;
            sp.formatProfitAmountTotalColor = numberFormatter(sp.holdProfitAmount).color;
            toApi_toAcCg('S15Q087', { fundCode: sp.fundCode }, function (spData) {
                sp.buyFlag = spData.isBuy;
                sp.risklevel = spData.fundRiskLevelCode;
            })
        })
        console.log(spFundList);
        setTimeout(function () {
            if (spFundList.length > 0) {
                $('#specialProductTitle').removeClass('none');
                $('#specialProductTable').removeClass('none');
                var htmlList = template('specialProduct', {
                    "list": spFundList
                });
                $('#specialProductList').html(htmlList);
            }
        }, 300)
    }, 'redemptionList', '', function (err) {
        if (err.respMsg) {
            alertMsg(err.respMsg);
        }
    })
}

// 点击卖出按钮
function gotoSale(fundCode) {
    toApi_toAcCg('S15Q032', { fundCode: fundCode }, function (data) {
        sale(fundCode, data.shareType, data.fundState, data.fundSubType, data.openDateStart, data.openDateEnd, data.nowTime, data.isPortfolioAsset)
    })
}
